/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PatchApiPurewaveSettingRadioMutationRequest, PatchApiPurewaveSettingRadioMutationResponse, PatchApiPurewaveSettingRadio400, PatchApiPurewaveSettingRadio401, PatchApiPurewaveSettingRadio403, PatchApiPurewaveSettingRadio500 } from "../../types/PatchApiPurewaveSettingRadio.ts";
import { patchApiPurewaveSettingRadioMutationResponseSchema, patchApiPurewaveSettingRadioMutationRequestSchema } from "../../zod/PureWaveSettingSchemas/patchApiPurewaveSettingRadioSchema.ts";

function getPatchApiPurewaveSettingRadioUrl() {
  const res = { method: 'PATCH', url: `/api/purewave-setting/radio` as const }  
  return res
}

/**
 * @summary Обновить статус радио
 * {@link /api/purewave-setting/radio}
 */
export async function patchApiPurewaveSettingRadio({ data }: { data?: PatchApiPurewaveSettingRadioMutationRequest }, config: Partial<RequestConfig<PatchApiPurewaveSettingRadioMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = patchApiPurewaveSettingRadioMutationRequestSchema.parse(data)  
  
  const res = await request<PatchApiPurewaveSettingRadioMutationResponse, ResponseErrorConfig<PatchApiPurewaveSettingRadio400 | PatchApiPurewaveSettingRadio401 | PatchApiPurewaveSettingRadio403 | PatchApiPurewaveSettingRadio500>, PatchApiPurewaveSettingRadioMutationRequest>({ method : "PATCH", url : getPatchApiPurewaveSettingRadioUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return patchApiPurewaveSettingRadioMutationResponseSchema.parse(res.data)
}